/** Cuadrado redondeado de 20px con el color del proyecto (CLAUDE.md §6). */
export function ProjectSwatch({ color }: { color: string }) {
  return (
    <span
      aria-hidden="true"
      className="h-5 w-5 shrink-0 rounded-card"
      style={{ backgroundColor: color }}
    />
  )
}
